<template>
  <page-block full-page>
    <page-content-placeholder :img-src="AccessDeniedImage" text="Доступ закрыт" max-width="640px">
      <div class="paragraph-m mt-1">
        Недостаточно прав для просмотра раздела. Обратитесь к администратору своего пространства, если вам необходим
        доступ.
      </div>
    </page-content-placeholder>
  </page-block>
</template>

<script setup lang="ts">
import AccessDeniedImage from '@/assets/img/layouts/access-denied.svg';
import PageContentPlaceholder from '@/core/components/common/PageContentPlaceholder.vue';
import PageBlock from '@/core/components/interface/PageBlock.vue';
</script>
